import { ToggleButtonGroup, VStack, makeUclComponent } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken } from 'styles/constants';

export const StyledDonationCard = VStack.withConfig({
  rounded: 'md',
  backgroundColor: getDesignToken('background-card'),
  padding: '$4',
});

export const StyledDonationTitle = withTypography({ variant: 'headerThree', mb: '$0' });

export const StyledDonationSubTitle = withTypography({ variant: 'copyTwo', fontSize: 'sm' });

export const StyledToggleButtonGroup = makeUclComponent(ToggleButtonGroup).withConfig({
  marginTop: '$4',
});
